import MileageSettingsUpdateRequest, {
  MileageSettingsUpdateRequestMileageNumberCreationModel,
} from "../../../../api/raily/mileage/settings/update/mileage-settings-update.request";
import MileageNumberCreationModel from "../../../../types/mileage-number-creation-model";
import MileageSettingsUpdateParams from "./mileage-settings-update-params";

const createCreationModel = (
  model: MileageNumberCreationModel | undefined,
): MileageSettingsUpdateRequestMileageNumberCreationModel | undefined => {
  switch (model) {
    case MileageNumberCreationModel.AUTO:
      return MileageSettingsUpdateRequestMileageNumberCreationModel.AUTO;
    case MileageNumberCreationModel.DICT:
      return MileageSettingsUpdateRequestMileageNumberCreationModel.DICT;
    case MileageNumberCreationModel.MANUAL:
      return MileageSettingsUpdateRequestMileageNumberCreationModel.MANUAL;
    default:
      return undefined;
  }
};

const create = (
  params: MileageSettingsUpdateParams,
): MileageSettingsUpdateRequest => {
  return {
    cargoCompanyUuid: params.cargoCompanyUuid,
    isCardNumberRequired: params.isCardNumberRequired,
    isMileageNumberRequired: params.isMileageNumberRequired,
    mileageNumberCreationType: createCreationModel(
      params.mileageNumberCreationModel,
    ),
  };
};

const mileageSettingsUpdateParamsFactory = {
  create,
};

export default mileageSettingsUpdateParamsFactory;
